import React from 'react';
import config from '../config/app.json';
import { FormattedMessage } from 'react-intl';
import { errorlog } from '../helpers/ErrorLogService';

export default class Toast extends React.Component {

    constructor(props) {
        super(props);
        this.state                  = {};
        this.closeToast             = this.closeToast.bind(this);
        this.appUrl                 = config['APPICONS'][config['APPICONS']['current']];
        this.timeout                = props.data.get("timeout") !== undefined ? props.data.get("timeout") : 3000;
        this.timer                  = null;
        this.start                  = null;
        this.handleMouseEnter       = this.handleMouseEnter.bind(this);
        this.handleMouseLeave       = this.handleMouseLeave.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
      let toReturn = null;
      return toReturn;
    }

    componentDidMount(){
      
        setTimeout(
            function() {
                this.toastElement.classList.add("visible");
            }
            .bind(this),
            10
        );
        if(this.props.data.get("autoClose") === undefined || this.props.data.get("autoClose") === true){
            this.start = Date.now();
            this.timer = window.setTimeout(this.closeToast, this.timeout);
        }
    }

    closeToast(){
        try{
        if(this.toastElement !== null)
            this.toastElement.classList.remove("visible");
        setTimeout(
            function() {
                this.props.manageToast({action : "delete", id : this.props.data.get("id")});
            }
            .bind(this),
            360
        );
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "Toast-closeToast")
        }
    }

    pauseTimout(){
        try{
        window.clearTimeout(this.timer);
        this.timeout -= Date.now() - this.start;
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "Toast-pauseTimout")
        }
    }

    resumeTimout(){
        try{
        this.start = Date.now();
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(this.closeToast, this.timeout);
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "Toast-resumeTimout")
        }
    }

    handleMouseEnter(e){
        try{
        if(this.props.data.get("autoClose") === undefined || this.props.data.get("autoClose") === true)
            this.pauseTimout();
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "Toast-handleMouseEnter")
        }
    }

    handleMouseLeave(e){
        try{
        if(this.props.data.get("autoClose") === undefined || this.props.data.get("autoClose") === true)
            this.resumeTimout();
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "Toast-handleMouseLeave")
        }
    }

    render() {
        let toastMsg;
       if(['both', 'msg'].indexOf(this.props.data.get('formatId')) === -1){
            toastMsg = <div className={"toast-message"}>{this.props.data.get("message")}</div>
       }else{
            if(this.props.data.get('lVal')){
                toastMsg = <div className={"toast-message"}><FormattedMessage id={this.props.data.get('message')} values={{'val' : this.props.data.get('lVal')}}></FormattedMessage></div>
            }else{
                toastMsg = <div className={"toast-message"}><FormattedMessage id={this.props.data.get('message')}></FormattedMessage></div>
            }
       }
        return(
            <div ref={(instance) => this.toastElement = instance} className = {"toast-notification " + this.props.data.get("type")} onMouseEnter = {this.handleMouseEnter} onMouseLeave = {this.handleMouseLeave}>
                <div className={"toast-container"}><img src= {this.appUrl + "/images/share/"+ this.props.data.get("type") +".svg"} />
                    <div className={"toast-content"}>
                        <div className = "toast-msg-container">
                            {toastMsg}
                            {(this.props.data.get("link") !== undefined && this.props.data.get("linkName") !== undefined)?<div className={"toast-link"}><a href={this.props.data.get("link")} target="_blank" alt="Externel Link">{this.props.data.get("linkName")}</a></div>:null}
                            {this.props.data.get("subMessage") !== undefined?(['both', 'sub'].indexOf(this.props.data.get('formatId')) === -1) ? <div className={"toast-sub-message"}>{this.props.data.get("subMessage")}</div> : <FormattedMessage id={this.props.data.get('subMessage')} children={val => <div className={"toast-sub-message"}>{val}</div>}></FormattedMessage> :null}
                        </div>
                    </div>
                </div>
                <img onClick = {this.closeToast} className={"close-toast"} src={this.appUrl + "/images/share/close.svg"}></img>
            </div>
        );
    }
  }



// WEBPACK FOOTER //
// ./src/components/Toast.js